import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { OptionContainer, Wrapper } from '../exercise/multiple-choice/styled.js';
import CheckBox from './check-box';
import { HIGHLIGHT_TYPES } from '../../constants/exercise';

export default class CheckBoxGroup extends PureComponent {
    static propTypes = {
        Component: PropTypes.func,
        name: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                text: PropTypes.string.isRequired,
                checked: PropTypes.bool,
                selected: PropTypes.bool,
                disabled: PropTypes.bool,
                highlight: PropTypes.oneOf(HIGHLIGHT_TYPES),
            }),
        ).isRequired,
        onChange: PropTypes.func,
        gap: PropTypes.string,
        direction: PropTypes.string,
    };

    static defaultProps = {
        direction: 'vertical',
        gap: 'base',
        Component: () => '',
        values: [],
    };

    handleChange = (event) => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(event.target.value, event.target.checked);
        }
    };

    render() {
        const { options, name, Component } = this.props;

        return (
            <Wrapper direction="vertical">
                {options.map((option, index) => {
                    return (
                        <OptionContainer key={index}>
                            <Component index={index} />
                            <CheckBox
                                disabled={option.disabled}
                                checked={option.checked}
                                value={option.id}
                                key={option.id}
                                highlight={option.highlight}
                                selected={option.checked}
                                name={name}
                                onChange={this.handleChange}
                            >
                                {option.text}
                            </CheckBox>
                        </OptionContainer>
                    );
                })}
            </Wrapper>
        );
    }
}
